module.exports = __webpack_public_path__ + "static/media/Skyscraper.21cd4a00.jpg";